import React, { Component, useState, useEffect  } from "react";
import { useNavigate, useLocation } from 'react-router-dom'




function Logout (props) {

const awcurl=sessionStorage.getItem("AWC_URL");
const resturl=sessionStorage.getItem("REST_URL");
const navigate = useNavigate();	

useEffect(() => {
console.log('logout will clear session and navigate to login');
sessionStorage.clear();
navigate('/');

},[]);






/*
const location = useLocation();
console.log('location.pathname: '+location.pathname);
console.log('window.location: '+window.location);

*/
}//end class



export default Logout; 

